export default "__VITE_ASSET__6d7884df__"